import styled from '@emotion/styled';
import { StyledProps } from './NavDivider.types';
import { css } from '@styled-system/css';
import { variant } from 'styled-system';

export default styled.div<StyledProps, any>`
  ${css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 3,
    py: 0,
  })}
  ${variant({
    variants: {
      website: {
        rect: {
          fill: 'var(--color-extra-white)',
        },
      },
      white: {
        rect: {
          fill: 'var(--color-indigo-t11)',
        },
      },

      light: {
        rect: {
          fill: 'var(--color-indigo-t11)',
        },
      },
      dark: {
        rect: {
          fill: 'var(--color-extra-white)',
        },
      },
    },
  })}
`;
